import styled from "@emotion/styled";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

export const Container = styled.div`
  position: relative;
`;

export const CalendarContainer = styled.div`
  position: absolute;
  z-index: 1;
`;
